const QUANTITY_FORMATTER = new Intl.NumberFormat('en-US', { maximumFractionDigits: 9 });
export function formatQuantity(value, uomAbbr) {
    if (value == null) {
        return null;
    }
    const formatted = QUANTITY_FORMATTER.format(value);
    return uomAbbr ? `${formatted} ${uomAbbr}` : formatted;
}
//# sourceMappingURL=format-quantity.js.map